export default __webpack_public_path__ + "static/media/gallery_3_768.01ca6876.webp";